import { t } from 'i18next';

import { showConfirmDialog } from './messageDialog';
import { setLoadingState } from './progressIndicator';
import { MessageDialogTypes } from '../components/MessageDialog/MessageDialog';
import { UNAUTHORIZED_HTTP_CODE } from '../service/Error';
import { showModal, TYPES } from './modal';

const UPDATE_DOCUMENTS_STATUS = 'UPDATE_DOCUMENTS_STATUS';

const GET_DOCUMENTS_LIST = 'GET_DOCUMENTS_LIST';

function showPdf(id, onShow, extension) {
    return (dispatch, getState, { plugins }) => {
        plugins.pdf.show(id, onShow, extension).catch(() => {
            setTimeout(
                () =>
                    dispatch(
                        showConfirmDialog({
                            title: t('errMessage'),
                            message: t('errors.openFile'),
                            btnCancelVisibility: false,
                            options: {
                                type: MessageDialogTypes.ERROR,
                            },
                        })
                    ),
                1000
            );
        });
    };
}

function downloadDocuments(ids) {
    return (dispatch, getState, { apiManager }) => {
        return ids.reduce((promise, id) => {
            return promise.then((res) => {
                return apiManager
                    .downloadFile(id)
                    .then(() => {
                        res.downloaded.push(id);

                        return res;
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err.errorCode === UNAUTHORIZED_HTTP_CODE) {
                            dispatch(setLoadingState(false));
                            dispatch(showModal(TYPES.RELOGIN, {}));
                            return;
                        }
                        res.errors.push(id);

                        return res;
                    });
            });
        }, Promise.resolve({ downloaded: [], errors: [] }));
    };
}

function downloadDocument(id, name) {
    return (dispatch, getState, { apiManager }) => {
        dispatch(setLoadingState(true, t('messages.downloadDocument', { name })));

        return apiManager
            .downloadFile(id)
            .then(() => {
                dispatch({ type: UPDATE_DOCUMENTS_STATUS, data: { downloaded: [id] } });
                dispatch(setLoadingState(false));
            })
            .catch((err) => {
                if (err.errorCode === UNAUTHORIZED_HTTP_CODE) {
                    dispatch(setLoadingState(false));
                    dispatch(showModal(TYPES.RELOGIN, {}));
                    return;
                }

                dispatch(
                    showConfirmDialog({
                        title: t('errMessage'),
                        message: t('errors.uploadDocument'),
                        btnCancelVisibility: false,
                        options: {
                            type: MessageDialogTypes.ERROR,
                        },
                    })
                );
                dispatch(setLoadingState(false));
            });
    };
}

function downloadAllDocuments(ids) {
    return (dispatch) => {
        dispatch(setLoadingState(true, t('messages.downloadDocuments')));
        return Promise.all([dispatch(downloadDocuments(ids))])
            .then(([data]) => {
                dispatch({ type: UPDATE_DOCUMENTS_STATUS, data: data });
                if (data.errors.length || data.errors.length) {
                    // // Cannot re-open Dialog immediately, need timeout fro it
                    // setTimeout(() =>{
                    dispatch(
                        showConfirmDialog({
                            title: t('errMessage'),
                            message: t('errors.uploadDocuments'),
                            btnCancelVisibility: false,
                            options: {
                                type: MessageDialogTypes.ERROR,
                            },
                        })
                    );
                    // }, 1000)
                }
                dispatch(setLoadingState(false));
            })
            .catch(() => {
                dispatch(setLoadingState(false));
                // throw new Error('Failed to load documents from the server. Please try again later!');
            });
    };
}

export { GET_DOCUMENTS_LIST, UPDATE_DOCUMENTS_STATUS, showPdf, downloadAllDocuments, downloadDocument };
